import { defaultHttpClient } from '../../httpClient';
import type { GetMarketCategoriesResponse } from './types';

export const getMarketCategories = (marketId: number) => {
  return defaultHttpClient
    .request<GetMarketCategoriesResponse>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/categories`,
    })
    .then(result => result.data);
};
